export function useDictUtil({
  options,
  config = {
    key: 'key',
    text: 'text'
  }
}) {
  /**
   * 状态选项map
   */
  const dict = options.reduce((map, e) => {
    map[e[config.key]] = e;
    return map;
  }, {});

  /**
   * 状态选项map
   */
  const dictTextMap = options.reduce((map, e) => {
    map[e[config.text]] = e;
    return map;
  }, {});

  const _enum = {
    ...dict,
    ...dictTextMap
  };

  /**
   * 获取状态文本
   * @param {string|number} state
   */
  function getTextByKey(state) {
    if (!(state in dict)) return;

    return dict[state][config.text];
  }

  function getKeyByText(text) {
    if (!(text in dictTextMap)) return;
    return dictTextMap[text][config.key];
  }

  function getOptionByKey(key) {
    if (!(key in dict)) return;
    return dict[key];
  }

  function getOptionByProp(prop, value) {
    const item = options.find(e => e[prop] === value);

    return item;
  }

  return {
    options,
    dict,
    enum: _enum,
    getTextByKey,
    getKeyByText,
    getOptionByKey,
    getOptionByProp
  };
}
